<template>
  	<AddNewReseller />
</template>

<script>

// @ is an alias to /src
import AddNewReseller from "@/components/Client/Resellers/ResellerForm.vue";

export default {
  name: "AddNewResellers",
  components: {
    AddNewReseller,
  },
};
</script>
